export type LeadStatus = 'new' | 'in_progress' | 'cancelled' | 'completed';

export const LEAD_STATUSES: LeadStatus[] = ['new', 'in_progress', 'cancelled', 'completed'];

export const LEAD_STATUS_LABELS: Record<LeadStatus, string> = {
  new: 'Новый',
  in_progress: 'В работе',
  cancelled: 'Отменен',
  completed: 'Завершен',
};

export const DEFAULT_LEAD_STATUS: LeadStatus = 'new';

const LEGACY_STATUS_MAP: Record<string, LeadStatus> = {
  новый: 'new',
  'в работе': 'in_progress',
  отменен: 'cancelled',
  завершен: 'completed',
};

export const normalizeLeadStatus = (status?: string | null): LeadStatus => {
  if (!status) {
    return DEFAULT_LEAD_STATUS;
  }

  if (LEAD_STATUSES.includes(status as LeadStatus)) {
    return status as LeadStatus;
  }

  return LEGACY_STATUS_MAP[status] ?? DEFAULT_LEAD_STATUS;
};

export const getLeadStatusLabel = (status?: string | null): string => {
  return LEAD_STATUS_LABELS[normalizeLeadStatus(status)];
};

export const getLeadStatusClassName = (status?: string | null): string => {
  switch (normalizeLeadStatus(status)) {
    case 'new':
      return 'statusNew';
    case 'in_progress':
      return 'statusInProgress';
    case 'cancelled':
      return 'statusCancelled';
    case 'completed':
      return 'statusCompleted';
    default:
      return 'statusNew';
  }
};
